import type { PropsWithChildren } from 'react'
import { css } from '~/styled-system/css'
import { Button } from '~/ui'

export function CheckboxPopup({
  children,
  update,
  cancel,
}: PropsWithChildren<{ update: (v: any) => void; cancel: () => void }>) {
  return (
    <Popup>
      <div className={css({ spaceY: '3' })}>{children}</div>
      <div className={css({ display: 'flex', justifyContent: 'end', gap: '1', mt: '4' })}>
        <button
          type="button"
          onClick={cancel}
          className="px-3 py-2 text-sm leading-none text-neutral-700"
        >
          キャンセル
        </button>
        <Button color="tertiary" size="xs" onClick={update}>
          決定
        </Button>
      </div>
    </Popup>
  )
}

export function RadioButtonPopup({ children }: PropsWithChildren) {
  return (
    <Popup>
      <div className={css({ spaceY: '3' })}>{children}</div>
    </Popup>
  )
}

// TODO: Radix UI で実装する
// https://www.radix-ui.com/primitives/docs/components/popover
export function Popup({ children }: PropsWithChildren) {
  return <div className="min-w-52 rounded p-3 shadow-outline">{children}</div>
}
